module.exports = __webpack_public_path__ + "static/assets/e9aca22d178bce9963d344d613ce76be.png";